import { render, staticRenderFns } from "./FunctionalitySupport.vue?vue&type=template&id=73c5df2f&"
import script from "./FunctionalitySupport.vue?vue&type=script&lang=js&"
export * from "./FunctionalitySupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports